export { downloadBlob } from 'utils/download'

/** Trigger a file download from a ready URL (used for PDF viewer modals). */
export const downloadFromUrl = (url: string, filename: string) => {
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}
